import React, { Component } from 'react';

class HorizontalAlignment extends Component {
  render() {
    let { value, onChange } = this.props.input;
    return (
      <div className="field is-horizontal">
        <div className="field-label is-small">
          <label className="label">Alignment</label>
        </div>
        <div className="field-body">
          <div className="field has-addons is-fullwidth">
            <p className="control">
              <button
                type="button"
                className={`button is-small ${value === 'left' ? 'is-active' : ''}`}
                onClick={(e) => {
                  onChange('left');
                }}
              >
                <span className="icon is-small">
                  <i className="fas fa-align-left"></i>
                </span>
              </button>
            </p>
            <p className="control">
              <button
                type="button"
                className={`button is-small ${
                  value === 'center' ? 'is-active' : ''
                }`}
                onClick={(e) => {
                  onChange('center');
                }}
              >
                <span className="icon is-small">
                  <i className="fas fa-align-center"></i>
                </span>
              </button>
            </p>
            <p className="control">
              <button
                type="button"
                className={`button is-small ${
                  value === 'right' ? 'is-active' : ''
                }`}
                onClick={(e) => {
                  onChange('right');
                }}
              >
                <span className="icon is-small">
                  <i className="fas fa-align-right"></i>
                </span>
              </button>
            </p>
          </div>
        </div>
      </div>
    );
  }
}
export default HorizontalAlignment;
